module.exports = __webpack_public_path__ + "img/coupon_bg_popup_2.b7b0284.png";